import axios from ".";

export const getUserRolePermissions = (tenantId: number, params?: any) => {
  return axios({
    method: "GET",
    url: `/user-role-permissions`,
    params: { tenantId, ...params },
  });
};

export const manageNewRole = (params: any) => {
  return axios({
    method: "GET",
    url: `/user-role-permissions/role-exist`,
    params,
  });
};

export const createNewUserRole = (data: any, params: any) => {
  return axios({
    method: "POST",
    url: `/user-role-permissions/create-role`,
    data,
    params,
  });
};

export const updateRolePermissions = (data: any, params: any) => {
  return axios({
    method: "PUT",
    url: `/user-role-permissions`,
    data,
    params,
  });
};

export const getManageReports = (params: any) => {
  return axios({
    method: "GET",
    url: `/users/reports`,
    params:{
      ...params,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    },
  });
};


export const addUserReports = (data: any, params: any) => {
  return axios({
    method: "POST",
    url: `/users/reports/export`,
    params:{
      ...params,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    },
    data,

  });
};